import xhttp from '@utils/xhttp'

// 开启集成开放平台
export function openStarMap(appId) {
    return xhttp.put(`/api/console-proxy/app/${appId}/enable-xingtu`)
}

// 获取集成开放平台详情
export function getStarMapDetail(appId) {
    return xhttp.get(`/api/console-proxy/app/${appId}/xingtu`)
}

// 保存集成开放平台环境配置
export function saveStarMapEnvDeploy(data) {
    return xhttp.put(`/api/console-proxy/app/${data.appId}/xingtu`, data.params)
}

export function getEnvBindingList(data) {
    return xhttp.get(`/api/console-proxy/app/${data.appId}/xingtu-env-binding`, { params: data.params })
}

export function getMipEnvList(appId) {
    return xhttp.get(`/api/console-proxy/app/${appId}/xingtu-env`)
}

// 获取集成开放平台api列表
export function getMipApiList(params) {
    const { xingTuEnvId, ...others } = params
    return xhttp.get(`/api_v3/studio/star-map/api/${xingTuEnvId}/list`, { params: others })
}

// 获取集成开放平台api的详情
export function getMipApiDetail(params) {
    const { xingTuEnvId, id, ...others } = params
    return xhttp.get(`/api_v3/studio/star-map/api/${xingTuEnvId}/${id}`, { params: others })
}

// 获取集成开放平台历史api的详情
export function getMipApiHistoryDetail(params) {
    const { id, ...others } = params
    return xhttp.get(`/api_v3/studio/star-map/api/service/${id}`, { params: others })
}

// 添加环境映射
export function addEnvMap(data) {
    return xhttp.put(`/api/console-proxy/app/${data.appId}/xingtu-env-binding`, data.params)
}

// 删除环境映射
export function deleteEnvMap(data) {
    return xhttp.delete(`/api/console-proxy/app/${data.appId}/xingtu-env-binding`, { params: data.params })
}

// 获取业务环境列表
export function getBusinessEnvListByCategory(data) {
    return xhttp.get('/api/console-proxy/business-env-list-by-category', { params: data })
}

// 获取集成开放平台绑定信息
export function getStarMapBindingDetail(data) {
    return xhttp.get(`/api/console-proxy/app/${data.appId}/env/${data.envId}/xingtu-env-binding`)
}

export function updateStarMapInfo(params) {
    return xhttp.put(`/api_v3/studio/star-map/update/service/${params.id}`, params)
}

// 更新单个api
export function updateStarMipApi(params) {
    const { apiServiceId, ...others } = params
    return xhttp.put(`/api_v3/studio/star-map/update/service/${apiServiceId}/single`, others)
}

// 需要更新的服务api
export function updateStarMipApiList(params) {
    const { appId, xingTuEnvId, ...others } = params
    return xhttp.get(`/api_v3/studio/star-map/update/app/${appId}/xingTuEnv/${xingTuEnvId}/list`, { params: others })
}
